import React, { useEffect } from 'react'
import { Error } from '../../components'
import { getCallbackError } from '../../utils/errors'
import { newRelicTriggerErrorEvent } from '../../utils/newrelic'

type Props = {
  location: {
    search: string
  }
}

export default function BrowseCallbackError({ location: { search } }: Props): JSX.Element {
  const error = getCallbackError(search)

  useEffect(() => {
    newRelicTriggerErrorEvent('browse-callback-error', error.code)
  }, [])

  return (
    <div data-test="browse-callback-error">
      <Error {...error} />
    </div>
  )
}
